import React, {useContext} from "react";
import {BoShowContext} from "../context/bo-show-context.jsx";
import {BoKeys} from "../../resources/bo-keys.js";
import {getAssetPath} from "../../../../../utils/get-asset-path.js";
import {getIndividualLabel, isBoImageExtension} from "../utils/bo-show-utils.js";
import InputCheckbox from "../../../../../components/input/input-checkbox.jsx";

const API_URL = import.meta.env.VITE_API_URL;

const BoShowApprehensions = () => {
    const {boData, verifySyncUrl, printOptions, attachesToHide, handleAttachToHide, setModalAttach} = useContext(BoShowContext);
    const apprehensionList = boData?.apprehensionList?.filter((item) => !item?.relatedVehicle);

    if (!apprehensionList?.length) return null;

    const openModal = (relatedPhotoFace) => {
        if (!relatedPhotoFace) return;

        setModalAttach({open: true, attach: relatedPhotoFace})
    }

    return (
        <>
            {
                apprehensionList.map((apprehension, index) => {
                    const attachment = apprehension?.attachs?.[0];
                    if (attachment) {
                        attachment.url = `${verifySyncUrl(attachment.attachId)}/${attachment.attachId}`;
                    }

                    return (
                        <article key={apprehension?.itemId ?? index} className={"space-y-4"}>
                            <h2 className={"resume-title"}>APREENSÃO  - {index + 1}</h2>

                            <section className={"grid grid-cols-12 gap-3"}>
                                <div className={"col-span-4"}>
                                    <div className={"image relative"}>
                                        {
                                            printOptions?.image && attachment?.attachId &&
                                            <InputCheckbox
                                                id={"attach-check-" + attachment.attachId}
                                                checked={!attachesToHide.includes(attachment.attachId)}
                                                label={"Exibir"}
                                                onChange={() => handleAttachToHide(attachment.attachId)}
                                                className={"absolute top-[5px] left-[10px] print:hidden"}
                                            />
                                        }
                                        <img
                                            className={(printOptions?.image && !attachesToHide.includes(attachment?.attachId) && attachment?.attachId ? "print:block" : " print:hidden")}
                                            src={
                                                !!attachment ? isBoImageExtension(attachment?.extension)
                                                    ? (attachment?.attachId ? `${verifySyncUrl(attachment.attachId)}/${attachment.attachId}` : getAssetPath("img/no-img.png"))
                                                    : getAssetPath(`img/file-types/${attachment?.name?.split(".")?.pop()}.png`) : getAssetPath("img/no-img.png")
                                            }
                                            alt={`Apreensão ${index + 1}`}
                                            onClick={() => openModal(attachment)}
                                        />
                                        <img
                                            className={"hidden" + (!attachment?.attachId || (!printOptions?.image || attachesToHide.includes(attachment.attachId)) ? " print:block" : "")}
                                            src={getAssetPath("img/no-img.png")}
                                            alt=""
                                        />
                                    </div>
                                </div>

                                <div className={"col-span-8 grid grid-cols-2 gap-2 self-start"}>
                                    <p className={"col-span-2"}>Indivíduo: <span className={"info"}>{getIndividualLabel(boData?.individualList, apprehension?.relatedPerson)}</span></p>
                                    <p>Tipo: <span className={"info"}>{apprehension?.type ?? ""}</span></p>
                                    <p>{apprehension?.type === "Celular" ? "IMEI" : "Subtipo"}: <span className={"info"}>{apprehension?.type === "Celular" ? (apprehension?.imei ?? "") : (apprehension?.subtype ?? "")}</span></p>
                                    <p>Quantidade: <span className={"info"}>{apprehension?.quantity ?? ""}</span></p>
                                    <p>Unidade: <span className={"info"}>{BoKeys[apprehension?.unit] ?? apprehension?.unit ?? ""}</span></p>
                                    <p className={"col-span-2"}>Destino: <span className={"info"}>{apprehension?.destination ?? ""}</span></p>
                                    <p className={"col-span-2"}>Recebedor: <span className={"info"}>{apprehension?.receiver ?? ""}</span></p>
                                    <p className={"col-span-2"}>Descrição: <span className={"info"}>{apprehension?.description ?? ""}</span></p>
                                </div>
                            </section>
                        </article>
                    );
                })
            }
        </>
    );
};

export default BoShowApprehensions;
